import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import calendar from "../../../../../../../assets/images/meetupEvent/calendar.png";
import Clock from "../../../../../../../assets/images/meetupEvent/clock-icon.png";
import Fly from "../../../../../../../assets/images/Souvenir/unsplash_Z4RYz52ljts.png";
import Price from "../../../../../../../assets/images/tagPrice.PNG";
// import SouvenirAuctionBanner from '../../../../../../assets/images/SouvenirJoti.png';
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";

const ConfirmOrEditSuperAuction = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const params = useParams();
  let history = useHistory();

  function handleClick() {
    history.push("/superstar/auction");
  }

  const [auctionConfirm, setConfirmation] = useState([]);

  useEffect(() => {
    axios
      .get(`/api/star/editOrConfirm/auction/editOrConfirm/${params.id}`)
      .then((res) => {
        if (res.status === 200) {
          setConfirmation(res.data.product);
        }
      });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8 mb-3">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + auctionConfirm.banner}
              className="img-fluid"
              alt=""
              style={{ maxHeight: "450px", width: "100%" }}
            />
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + auctionConfirm.product_image}
              className="img-fluid"
              alt=""
              style={{ maxHeight: "450px", width: "100%" }}
            />
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-md-12 ">
          <div className="card card-bg shadow">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="div mb-3">
                  <h4 className="text-light ">{auctionConfirm.name}</h4>
                </div>
                {auctionConfirm.name ? (
                  <div className="div text-warning mb-3">
                    <small>&nbsp;||&nbsp;</small>
                  </div>
                ) : (
                  <></>
                )}
                <div className="div mb-3">
                  <h5 className="text-light ">{auctionConfirm.title}</h5>
                </div>
              </div>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light">
                <Markup content={auctionConfirm.details} />
              </p>
            </div>
          </div>
        </div>
        <div className=" d-flex mt-5  cricket-jersey">
          <div className="d-flex p-2 mb-3  registration-btn card-bg ">
            <div className="mt-2  mx-3 ">
              <span className="text-light">
                {" "}
                <img src={calendar} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1">
              <span className="text-light">Bidding Date</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(auctionConfirm.from).format("LL")} -
                {moment(auctionConfirm.bid_to).format("LL")}
              </span>
            </div>
          </div>

          <div className=" d-flex p-2 mb-3 mx-md-2 registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Clock} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Time</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                {moment(auctionConfirm.bid_to).format("LT")}
              </span>
            </div>
          </div>
          <div className=" d-flex p-2 mb-3  registration-btn card-bg ">
            <div className=" mt-2 mx-3">
              <span className="text-light">
                {" "}
                <img src={Price} alt="" className="PriceTage" />
              </span>
            </div>
            <div className=" mx-1 ">
              <span className="text-light">Base Price</span>
              <br></br>
              <span className="text-warning  BtnTextNMP Usd fw-bold">
                ${auctionConfirm.base_price}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-2 mb-3">
          <button onClick={handleClick} className="btn btnCreate fw-bold w-100">
            Confirm
          </button>
        </div>
        <div className="col-md-2 mb-3 mx-md-3">
          <Link to={`/superstar/auction/edit/${auctionConfirm.id}`}>
            <button className="btn btnUpdate w-100 fw-bold">Edit</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ConfirmOrEditSuperAuction;
